import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

// ---------- toasts ----------
const ToastCtx = createContext(() => {});
export function ToastProvider({ children }) {
  const [lista, setLista] = useState([]);
  const avisar = useCallback((texto, tipo = 'ok') => {
    const id = Date.now() + Math.random();
    setLista(l => [...l, { id, texto, tipo }]);
    setTimeout(() => setLista(l => l.filter(t => t.id !== id)), 3500);
  }, []);
  return (
    <ToastCtx.Provider value={avisar}>
      {children}
      <div className="toasts">
        {lista.map(t => <div key={t.id} className={'toast ' + t.tipo}>{t.texto}</div>)}
      </div>
    </ToastCtx.Provider>
  );
}
export const useToast = () => useContext(ToastCtx);

// ---------- modal ----------
const pilhaModais = [];
export function Modal({ titulo, subtitulo, onFechar, children, rodape, largura }) {
  useEffect(() => {
    const id = {};
    pilhaModais.push(id);
    // Esc fecha só o modal de cima
    const esc = e => { if (e.key === 'Escape' && pilhaModais[pilhaModais.length - 1] === id) onFechar(); };
    window.addEventListener('keydown', esc);
    return () => {
      window.removeEventListener('keydown', esc);
      const i = pilhaModais.indexOf(id);
      if (i >= 0) pilhaModais.splice(i, 1);
    };
  }, [onFechar]);
  return (
    <div className="modal-fundo" onMouseDown={e => { if (e.target === e.currentTarget) onFechar(); }}>
      <div className="modal" style={largura ? { maxWidth: largura } : undefined}>
        <header>
          <div>
            <h2>{titulo}</h2>
            {subtitulo && <div className="mudo pequeno">{subtitulo}</div>}
          </div>
          <button className="fechar" onClick={onFechar} aria-label="Fechar">×</button>
        </header>
        <div className="corpo">{children}</div>
        {rodape && <footer>{rodape}</footer>}
      </div>
    </div>
  );
}

export function Campo({ label, children }) {
  return <div className="campo"><label>{label}</label>{children}</div>;
}

export function Chip({ status, children }) {
  return <span className={'chip ' + (status || 'neutro')}>{children}</span>;
}

export function Carregando() {
  return <div className="vazio">Carregando…</div>;
}
